import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { class: "my-4 d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "max-width": "700",
    "model-value": _ctx.isDialogOpen,
    "onUpdate:modelValue": _ctx.closeDialog
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_page_title, {
            value: _ctx.$t('foodMenu.importMenuDialog.title')
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_file_input, {
              "truncate-length": "15",
              accept: ".xlsx",
              placeholder: _ctx.$t('foodMenu.importMenuDialog.selectFile'),
              modelValue: _ctx.files,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.files) = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          (_ctx.isImporting)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "my-4"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              disabled: _ctx.isImporting || !_ctx.hasFile,
              onClick: _ctx.startImport
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('foodMenu.importMenuDialog.startImport')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_v_spacer)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}